import {Template} from "../../../../components/template/template.jsx";
import {Card} from "../../../../components/card/card.jsx";
import Button from "../../../../components/button/button.jsx";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import InputForm from "../../../../components/input/input-form.jsx";
import {useQuery} from "@tanstack/react-query";
import JourneyService from "../../../../services/web/journey.service.js";
import {agGridShiftComparator, workScheduleSpecialCases} from "../../work-schedule/work-schedule/form/utils/work-schedule-utils.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import CustomTimePicker from "../../../../components/custom-time-picker/custom-time-picker.jsx";
import ColorButton from "../../../../components/color-button/color-button.jsx";
import WorkScheduleService from "../../../../services/web/work-schedule-service.js";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {AgGridReact} from "ag-grid-react";
import {
    DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL,
    DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL_FLOATING_FILTERS
} from "../../../../utils/ag-grid-columns-utils.js";
import clsx from "clsx";
import TeamService from "../../../../services/web/team-service.js";
import {useParams} from "react-router";
import TreeUsers from "../../../../components/tree-user/tree-users.jsx";
import {Modal} from "../../../../components/modal/modal.jsx";
import Swal from "sweetalert2";
import UserService from "../../../../services/web/user-service.js";
import projectUtils, {clearRequiredFieldError} from "../../../../utils/project-utils.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {FaPlus} from "react-icons/fa";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputTextarea from "../../../../components/input/input-textarea.jsx";
import Alert from "../../../../components/alert/alert.jsx";


const initialTeam = {
    name: "",
    scale: "",
    start_hour: "",
    end_hour: "",
    color: "",
    status: true,
    teams_to_add: [],
    teams_to_remove: []
}

const specialCasesArr = workScheduleSpecialCases;
const TeamForm = () => {
    const [isLoading, setIsLoading] = useState(false)
    const {id} = useParams();
    const [team, setTeam] = useState(initialTeam);
    const [fullScale, setFullScale] = useState([]);
    const handleInput = useGeneralInputSpecialCase(setTeam);
    const [users, setUsers] = useState([]);
    const [hasSavedUsers, setHasSavedUsers] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [showModalAddUser, setShowModalAddUser] = useState(false);
    const [showModalRemoveUser, setShowModalRemoveUser] = useState(false);
    const [showModalInactivate, setShowModalInactivate] = useState(false);
    const [observation, setObservation] = useState("");
    const [gridApi, setGridApi] = useState(null);
    const [addUsersGridApi, setAddUsersGridApi] = useState(null);
    const [removeUsersGridApi, setRemoveUsersGridApi] = useState(null);
    const gridRef = useRef(null);
    const addUserGridRef = useRef(null);
    const removeUserGridRef = useRef(null);
    const colorRequiredRef = useRef(null);
    const columnDefs = useMemo(() => [
        {field: "turnNumber", headerName: "Turno", flex: 1},
        {field: "startTime", headerName: "Horário inicial", flex: 1,
            valueFormatter: params => params.value?.slice(0, 5)},
        {field: "endTime", headerName: "Horário final", flex: 1,
            valueFormatter: params => params.value?.slice(0, 5)},
        {field: "rest", headerName: "Descanso", flex: 1}

    ], []);
    const columnDefsUsers = useMemo(() => [
        { headerName: "Nome", field: "name",
            flex: 1,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            },
            cellRenderer: params => {
                return (<span className={"cell-custom"}>{params.value}</span>)
            }
        },
        { headerName: "Nome de guerra", field: "namewar",
            flex: 1,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            },
            cellRenderer: params => {
                return (<span className={"cell-custom"}>{params.value}</span>)
            }
        },], [])
    const navigate = navigateHook();

    useEffect(() => {
        clearRequiredFieldError(colorRequiredRef.current)
    }, [team.color]);

    const defaultColDef = DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL
    const defaultColDefAgents = DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL_FLOATING_FILTERS

    const {data: journeys, isSuccess: isSuccessJourneys} = useQuery({
        queryFn: () => JourneyService.getAllAvailableJourneys()
            .then(({data}) => data.sort((a,b) => agGridShiftComparator(a.pattern,b.pattern)).map(el => ({value: el.pattern,
                label: specialCasesArr.some(scale => scale.id === el.pattern) ?
                    specialCasesArr.find(scale => scale.id === el.pattern).name :
                    el.pattern})) ?? []),
        queryKey: ['work-schedule-journeys'],
    })

    useQuery({
        queryFn: () =>  WorkScheduleService.calculateScheduleTurns({
            journeyPattern: team.scale,
            startTime: projectUtils.formatTimeString(team.start_hour)
        }).then(({data}) => {
            setFullScale(data)
            return data
        }),
        queryKey: ['full-work-schedule-scales', team.scale, team.start_hour],
        enabled: !specialCasesArr.some(scale => scale?.id?.toLowerCase() === team?.scale?.toLowerCase())
            && (!!team?.scale && !!team?.start_hour),
        cacheTime: 0,
        staleTime: 0,
        refetchOnMount: true
    })

    const {
        refetch: refetchTeamUsers
    } = useQuery({
        queryFn: () => TeamService.getUsersInTeam(id).then(({data}) => {
            setUsers(data);
            setHasSavedUsers(data.length > 0);
            return data;
        }),
        queryKey: ['team-users', id],
        staleTime: 0,
        cacheTime: 0,
        refetchOnMount: true,
        enabled: !!id
    });

    useQuery({
        queryFn: () => TeamService.getUsersNotInTeam(id ?? -1000).then(({data}) => {
            setAllUsers(data);
            return data
        }),
        queryKey: ['team-all-users'],
        staleTime: 0,
        cacheTime: 0,
        refetchOnMount: true,
    })

    useEffect(() => {
        if(!id) return;
        const fetchTeam = async () => {
            const data = await TeamService.getTeam(id);

            const hrStart = data.start_hour ? data.start_hour.split(":") : null
            const hrEnd = data.start_hour ? data.end_hour.split(":") : null

            setTeam(prevState => ({
                ...prevState,
                name: data.name,
                color: data.color,
                start_hour: hrStart ? new Date(new Date().setHours(hrStart[0], hrStart[1], 0, 0)) : null,
                end_hour: hrEnd ? new Date(new Date().setHours(hrEnd[0], hrEnd[1], 0, 0)) : null,
                scale: data.scale,
                status: data.status,
                id: data.id
            }))
        }

        fetchTeam()
    }, [id]);

    useEffect(() => {
        const isSpecial = specialCasesArr.some(scale => scale.id?.toLowerCase() === team.scale?.toLowerCase());

        if (isSpecial && team.scale && team.start_hour && team.end_hour) {
            const scale = [{
                turnNumber: 1,
                startTime: projectUtils.formatTimeString(team.start_hour),
                endTime: projectUtils.formatTimeString(team.end_hour),
                rest: 1
            }];
            setFullScale(scale);
        }
        else if(!team.scale || !team.start_hour || !team.end_hour){
            setFullScale([])
        }
    }, [team.scale, team.start_hour, team.end_hour]);

    const prepareToRemove = () => {
        const ids = removeUsersGridApi
            .getSelectedRows()
            .map(row => row.id);
        setTeam(prevState => ({...prevState, teams_to_remove: ids}))

        const selectedUsers = users.filter(u => ids.includes(u.id));

        setUsers(prev =>
            prev.filter(u => !ids.includes(u.id))
        );

        setAllUsers(prev => [
            ...prev,
            ...selectedUsers
        ]);

        setShowModalRemoveUser(false);
    };

    const prepareToAdd = () => {
        if (!team.status) return;

        const ids = addUsersGridApi
            .getSelectedRows()
            .map(row => row.id);
        setTeam(prevState => ({...prevState, teams_to_add: ids}))

        const selectedUsers = allUsers.filter(u => ids.includes(u.id));

        setUsers(prev => [
            ...prev,
            ...selectedUsers
        ]);

        setAllUsers(prev =>
            prev.filter(u => !ids.includes(u.id))
        );

        setShowModalAddUser(false);
    };

    const onRowSelected = async (event) => {
        if (!event.node.isSelected()) return;

        const user = event.data;

        try {
            const { data } = await UserService.userHasTeam(user.id);

            if (data?.teamid && team?.id !== data.teamid) {
                const { isConfirmed } = await Swal.fire({
                    title: "Atenção",
                    text: "O agente já está em uma outra equipe! Tem certeza que deseja continuar?",
                    icon: "warning",
                    cancelButtonText: "Cancelar",
                    confirmButtonText: "Confirmar",
                    confirmButtonColor: "#063A6C",
                    reverseButtons: true,
                    showCancelButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });

                if (!isConfirmed) {
                    event.node.setSelected(false, true);
                }
            }
        } catch (err) {
            console.error(err);
        }
    };

    const openForm = () => {
        navigate('/team/form', false);
        setUsers([])
        setTeam(initialTeam)
    }

    const validate = () => {
        let message = "";

        if(!team.name){
            message = "O campo \"Nome\" é obrigatório.";
        } else if (!/^[^'"]*$/.test(team.name)) {
            message = `O campo "Nome" contém caracteres inválidos. (',")`;
        } else if(!team.start_hour) {
            message = "O campo \"Horário inicial\" é obrigatório.";
        } else if(!team.scale) {
            message = "O campo \"Jornada de trabalho\" é obrigatório.";
        } else if(!team.color) {
            message = "O campo \"Cor da equipe\" é obrigatório.";
        }

        if(specialCasesArr.some(scale => scale.id?.toLowerCase() === team.scale?.toLowerCase())){
            if(!team.end_hour) {
                message = "O campo \"Horário final\" é obrigatório.";
            }
        }
        return message;
    }

    const apply = async  () => {
        const hasError = validate();

        if(hasError){
            projectUtils.swalErrorMessage('', hasError, 'Ok');
            return;
        }

        const payload = {
            name: team.name,
            start_hour: projectUtils.formatTimeString(new Date(team.start_hour)),
            end_hour: specialCasesArr.some(
                scale => scale.id?.toLowerCase() === team.scale?.toLowerCase()
            ) ? projectUtils.formatTimeString(new Date(team.end_hour)) : "00:00",
            scale: team.scale,
            color: team.color,
            teams_to_add: JSON.stringify(team.teams_to_add),
            teams_to_remove: JSON.stringify(team.teams_to_remove),
        };
        setIsLoading(true);
        try {
            const response = team?.id ? await TeamService.update(team.id, payload) : await TeamService.save(payload);
            const { data } = response;

            if(!id){
                projectUtils.success(true);
                navigate(`/team/form/${data.id}`, false);
            } else {
                await refetchTeamUsers();
                setTeam(prevState => ({...prevState, teams_to_add: [], teams_to_remove: []}));
                projectUtils.success(false);
            }


        } catch (error) {
            console.error(error);

            let message = 'Não foi possível salvar.';
            if (error.response && error.response.status !== 500) {
                message = error.response.data.message;
            }
            projectUtils.swalErrorMessage('', message, 'Ok');
        } finally {
            setIsLoading(false);
        }
    }

    const updateStatus = async (data, successMessage = "Salvo com sucesso") => {
        setIsLoading(true);
        try {
            const {data: updatedTeam} = await TeamService.toggleStatus(team.id, data);
            setTeam(prevState => ({...prevState, status: updatedTeam.status, obs: updatedTeam.obs}));
            projectUtils.success(false, successMessage);
            return true;
        } catch (error) {
            const errorMessage = error.response?.data?.message;
            const message = errorMessage === "team.has.association"
                ? "Não é possível inativar a equipe enquanto houver agentes vinculados. Desvincule os agentes da equipe antes de inativá-la."
                : errorMessage || "Não foi possível alterar o status da equipe.";
            projectUtils.swalErrorMessage('', message, 'Ok');
            return false;
        } finally {
            setIsLoading(false);
        }
    }

    const toggleStatus = async () => {
        if (team.status) {
            setObservation("");
            setShowModalInactivate(true);
            return;
        }

        const {isConfirmed} = await Swal.fire({
            title: "Atenção",
            text: "Deseja ativar esta equipe?",
            icon: "warning",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Confirmar",
            confirmButtonColor: "#063A6C",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false
        });

        if (!isConfirmed) return;

        await updateStatus();
    }

    const inactivate = async () => {
        const wasInactivated = await updateStatus({obs: observation}, "Inativado com sucesso");

        if (!wasInactivated) return;

        setShowModalInactivate(false);

        if (hasSavedUsers || team.teams_to_add.length === 0) return;

        const pendingUserIds = team.teams_to_add;
        const pendingUsers = users.filter(user => pendingUserIds.includes(user.id));

        setUsers(prevState => prevState.filter(user => !pendingUserIds.includes(user.id)));
        setAllUsers(prevState => [
            ...prevState,
            ...pendingUsers.filter(user => !prevState.some(currentUser => currentUser.id === user.id))
        ]);
        setTeam(prevState => ({...prevState, teams_to_add: [], teams_to_remove: []}));
    }

    const showEndHour = specialCasesArr.some(
        scale => scale?.id?.toLowerCase() === team?.scale?.toLowerCase()
    );

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Equipe
                </Template.Title>
                { id &&
                    <Button onClick={openForm} target="primary-outline"><FaPlus/>Adicionar equipe</Button>
                }
            </Template.Header>
            <Template.Body>
                <Card>
                    <Card.Header>
                        <Card.Title>Dados</Card.Title>
                    </Card.Header>
                    <Card.Body className={clsx(
                        "grid !w-full grid-cols-1 gap-4 md:grid-cols-2",
                        showEndHour ? "xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_auto]" : "xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_auto]"
                    )}>

                        <InputForm
                            id="name"
                            value={team.name}
                            label="Nome *"
                            onChange={({target}) => handleInput("name", target.value)}
                        />

                        <SelectComponent
                            value={journeys?.find(option => team?.scale === option?.value) ?? null}
                            options={journeys}
                            label={"Jornada de trabalho *"}
                            onChange={option => handleInput("scale", option?.value ??  "")}
                        />

                        <InputDateTime
                            id="start_hour"
                            label="Horário inicial *"
                            selected={team.start_hour}
                            dateFormat="LT"
                            onChange={(value) => handleInput("start_hour", value)}
                        />


                        {showEndHour &&

                            <InputDateTime
                                id="end_hour"
                                label="Horário final *"
                                selected={team.end_hour}
                                dateFormat="LT"
                                onChange={(value) => handleInput("end_hour", value)}
                            />

                        }

                        <div className="flex items-center gap-2">
                            <span>Cor da equipe * : </span>
                            <ColorButton ariaLabel="Cor da equipe" color={team.color ?? ""} openOnFocus required buttonRef={colorRequiredRef} onChange={value => handleInput("color", value)}/>
                        </div>
                    </Card.Body>
                </Card>
                <div className="mt-2 flex gap-2 w-full">
                    <Card className="flex-1">
                        <Card.Header>
                            <Card.Title>Jornada de trabalho</Card.Title>
                        </Card.Header>
                        <Card.Body>
                           <div className="h-[calc(100vh-279px)]">
                               <AgGridReact
                                   onGridReady={(params) => {
                                       setGridApi(params.api);
                                   }}
                                   ref={gridRef}
                                   rowData={fullScale}
                                   columnDefs={columnDefs}
                                   defaultColDef={defaultColDef}
                                   animateRows={false}
                                   suppressCellFocus={true}
                                   gridOptions={{localeText: aggridUtils.localization()}}
                                   theme={aggridUtils.generalTheme()}
                               />
                           </div>
                        </Card.Body>
                    </Card>
                    <Card className="flex-1">
                        <Card.Header>
                            <Card.Title>Efetivo</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <TreeUsers users={users}/>
                        </Card.Body>
                        <Card.Footer>
                            <div className="flex gap-2 w-full justify-end items-center">
                                <Button target="danger" onClick={() => setShowModalRemoveUser(true)}>Remover agentes</Button>
                                <Button
                                    onClick={() => setShowModalAddUser(true)}
                                    disabled={!team.status}
                                    title={!team.status ? "Ative a equipe para adicionar agentes." : undefined}
                                >
                                    Adicionar agentes
                                </Button>
                            </div>
                        </Card.Footer>
                    </Card>
                </div>
                <Card className="mt-2">
                    <Card.Body className="flex gap-2 justify-end items-center">
                        {team.status && hasSavedUsers &&
                            <Alert target="warning" className="flex h-[32px] items-center">
                                Não é possível inativar, pois existem agentes associados à equipe.
                            </Alert>
                        }
                        {id &&
                            <Button
                                target={team.status ? "danger" : "primary"}
                                onClick={toggleStatus}
                                disabled={team.status && hasSavedUsers}
                                actionFeedbackType={!team.status ? "save" : undefined}
                                deferActionFeedback={!team.status}
                                loadingText="Ativando..."
                                successText="Ativado com sucesso"
                            >
                                {team.status ? "Inativar" : "Ativar"}
                            </Button>
                        }
                        <Button target="primary" onClick={apply} actionFeedbackType='save'>Salvar</Button>
                    </Card.Body>
                </Card>
            </Template.Body>
            <Modal open={showModalAddUser} setOpen={setShowModalAddUser} title="Adicionar agentes" className="w-6/12">
                <Modal.Body>
                    <div className="h-[calc(100vh-350px)] aggrid-row-pointer">
                        <AgGridReact
                            onGridReady={(params) => {
                                setAddUsersGridApi(params.api);
                            }}
                            ref={addUserGridRef}
                            rowData={allUsers}
                            columnDefs={columnDefsUsers}
                            defaultColDef={defaultColDefAgents}
                            rowSelection={{
                                mode: 'multiRow',
                                enableSelectionWithoutKeys: true,
                                enableClickSelection: true,
                                checkboxes: false,
                                headerCheckbox: false,
                            }}
                            onRowSelected={onRowSelected}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                            onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={prepareToAdd}>Adicionar</Button>
                </Modal.Footer>
            </Modal>
            <Modal open={showModalRemoveUser} setOpen={setShowModalRemoveUser} title="Remover agentes" className="w-6/12">
                <Modal.Body>
                    <div className="h-[calc(100vh-350px)] aggrid-row-pointer">
                        <AgGridReact
                            onGridReady={(params) => {
                                setRemoveUsersGridApi(params.api);
                            }}
                            ref={removeUserGridRef}
                            rowData={users}
                            columnDefs={columnDefsUsers}
                            defaultColDef={defaultColDefAgents}
                            rowSelection={{
                                mode: 'multiRow',
                                enableClickSelection: true,
                                enableSelectionWithoutKeys: true,
                                checkboxes: false,
                                headerCheckbox: false,
                            }}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                            onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button target="danger" onClick={prepareToRemove}>Remover</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                open={showModalInactivate}
                setOpen={setShowModalInactivate}
                title="Inativação da equipe"
                className="w-4/12"
            >
                <Modal.Body className="p-2">
                    <InputTextarea
                        label="Observações"
                        value={observation}
                        textAreaClass="h-25"
                        onChange={({target: {value}}) => setObservation(value)}
                    />
                </Modal.Body>
                <Modal.Footer className="p-2">
                    <div className="flex w-full justify-end">
                        <Button target="danger" onClick={inactivate} actionFeedbackType="save" loadingText="Inativando..." successText="Inativado com sucesso">Inativar</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </Template>
    )
}

export default TeamForm;